import React from 'react';
import styles from './WhatsAppSupport.module.scss';
import { useTranslation } from 'react-i18next';
import { useSettings } from '../../../context/SettingsContext';

export interface WhatsAppSupportProps {
  variant?: 'fab' | 'pill';
  // phoneNumber is no longer required via props, it will fetch from SettingsContext, but kept for fallback
  phoneNumber?: string;
}

export const WhatsAppSupport: React.FC<WhatsAppSupportProps> = ({ variant = 'fab', phoneNumber = '' }) => {
  const { t } = useTranslation();
  const { getSetting } = useSettings();
  
  // Use context setting first, then fallback to prop
  const activePhoneNumber = getSetting('whatsapp_support_number', phoneNumber);

  const copy = {
    title: t('support.whatsapp.title', 'Asistencia técnica por WhatsApp'),
    body: t('support.whatsapp.body', 'Dudas sobre uso, registro y soporte técnico de la plataforma'),
    emergency: t('support.whatsapp.emergency', 'No es un canal para emergencias.')
  };

  const WhatsAppIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M5.2 19.2 6.1 16A7.7 7.7 0 1 1 9 18.8l-3.8.4Z" />
      <path d="M9.6 8.7c.2-.4.4-.4.7-.4h.4c.2 0 .4 0 .5.4l.6 1.4c.1.3.1.5-.1.7l-.4.5c-.2.2-.2.4 0 .7.4.8 1.2 1.6 2.1 2 .3.2.5.2.7 0l.6-.7c.2-.2.4-.2.7-.1l1.4.7c.3.1.4.3.4.6 0 .5-.2 1.1-.6 1.4-.5.4-1.4.5-2.8-.1-2.2-.9-4.1-2.8-5-5-.5-1.2-.5-2.2-.1-2.7Z" />
    </svg>
  );

  const handleClick = () => {
    const textMessage = "Hola, equipo de Bodhiwell. Necesito ayuda con el uso, registro o soporte técnico de la plataforma.\nMi consulta es:";
    const query = `?text=${encodeURIComponent(textMessage)}`;
    
    if (activePhoneNumber) {
      window.open(`https://wa.me/${activePhoneNumber.replace(/[^0-9]/g, '')}${query}`, '_blank');
    } else {
      console.warn("WhatsAppSupport: No phone number provided.");
      window.open(`https://wa.me/${query}`, '_blank');
    }
  };

  return (
    <div className={styles.whatsappWrapper}>
      <div className={styles.helpBubble} role="note">
        <strong>{copy.title}</strong>
        <span>{copy.body}</span>
        <span>{copy.emergency}</span>
      </div>

      <button 
        className={variant === 'pill' ? styles.whatsappPill : styles.whatsappFab}
        aria-label={copy.title}
        onClick={handleClick}
      >
        <WhatsAppIcon />
        {variant === 'pill' && <span>Asistencia técnica</span>}
      </button>
    </div>
  );
};
